<template>
    <div id="popup" class="tw-absolute tw-top-0" v-if="user">
        <div class="tw-relative">
        <div id="arrow" class="tw-absolute tw-top-3"></div>
        <div id="inner" class="tw-bg-white tw-shadow tw-rounded tw-p-7">
            <div class="tw-flex tw-mb-4">
                <img :src="user.avatar" class="detail-img  tw-rounded tw-mr-5" />
                <div class="tw-flex tw-flex-col tw-justify-center">
                    <p class="tw-font-bold tw-text-xl tw-mb-2">{{user.firstname + ` ` + user.lastname}}</p>
                    <p class="tw-text-base">{{user.username}}</p>
                    <!-- <p class="tw-text-base">🏓 Ondernemers Friesland</p> -->
                </div>
            </div>
            <div class="tw-flex">
                <a :href="'/profile/' + user.username" class="tw-py-4 tw-mr-2 tw-w-full tw-text-lg tw-text-center tw-font-bold tw-rounded tw-bg-blue-100 hover:tw-bg-blue-200 tw-text-blue-500 tw-flex tw-justify-center tw-items-center tw-cursor-pointer">
                    <i class="far fa-user tw-text-blue-500 tw-pt-1 tw-mr-2" ></i>
                    <span>{{ translations['profile.view_profile'] }}</span>
                </a>
                <a :href="url" class="tw-py-4 tw-w-full tw-text-lg tw-text-center tw-font-bold tw-rounded tw-bg-blue-500 hover:tw-bg-blue-600 tw-text-white tw-flex tw-justify-center tw-items-center tw-cursor-pointer">
                    <i class="far fa-comment tw-text-white tw-pt-1 tw-mr-2" ></i>
                    <span>{{ translations['profile.send_message'] }}</span>
                </a>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js';

    export default {
        name: 'UserIconPopup',
        props: ['userId'],
        mixins: [Global],
        data(){
            return {
                user:null,
                url: ''
            }
        },
        methods:{
            async fetchUser() {
                const response = await axios.get(`/api/v3/users/${this.userId}`);
                this.user = response.data.data;
            },
            messageUrl() {
                axios.get(`/api/v3/inbox?user_id=${this.userId}`).then(response => {
                    if(Object.keys(response.data.data).length > 0) {
                        // there is an active thread
                        const {id} = response.data.data;
                        this.url = `/messages?thread_id=${id}`;
                    } else {
                        this.url = `/messages?participant_id=${this.userId}`;
                    }
                });

            }
        },
        mounted() {
            this.fetchUser();
            this.messageUrl();
        }
    }
</script>

<style lang="scss" scoped>
    #popup {
        display: none;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
        z-index: 2;

        @media (min-width: 768px) {
            display: block;
            transform: translateX(calc(50px + 12px));
            width: 428px;
            margin-right: 20px;
        }

        @media (min-width:1500px) {
            transform: translateX(calc(-100% - 12px));
            width: 428px;
            margin-right: 20px;
        }

        #arrow {
            display: none;

            @media (min-width: 768px) {
                display: block;
                transform: translateX(calc(-12px));
                left:0px;
                width: 0; 
                height: 0; 
                border-top: 12px solid transparent;
                border-bottom: 12px solid transparent;
                border-right: 12px solid white;
            }
            @media (min-width:1500px) {
                width: 0; 
                height: 0; 
                border-top: 12px solid transparent;
                border-bottom: 12px solid transparent;
                border-left: 12px solid white;
                border-right:0;
                transform: translateX(12px);
                right:0px;
                left:auto;
                margin-right: 0px;
            }
        }

        .detail-img {
            // width:82px;
            // height: 82px;
            width:62px;
            height: 62px;
        }

    }
</style>